<template lang='pug'>
  .fpui-store-package-editor
    .action-container
      i.fpui.fpui-remove(@click='close()')
      i.fpui.fpui-check(@click='save()')
    fp-loader(v-if='loading || !item')
    fpui-package-editor(
      v-else
      :consumer='consumer',
      :type='type',
      :id='id',
      :value='item'
      @input='update'
      :errors='errors'
      :is-new='isNew'
    )
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import FpuiPackageEditor from '@/components/PackageEditor'

export default {
  components: { FpuiPackageEditor },
  data () {
    return {
      item: null,
      errors: { name: false, owner: false },
      consumer: this.$route.params.consumer,
      type: this.$route.params.type,
      id: this.$route.params.id,
      unsubscribe: null
    }
  },
  computed: {
    isNew () { return !this.id },
    loading () { return this.$store.state.packages.loading }
  },
  created () {
    this.item = cloneDeep(this.$store.getters.PACKAGES_ITEM(this.$route.params.consumer, this.$route.params.type, this.$route.params.id)) || {}
    this.unsubscribe = this.$store.subscribe(({ type }) => {
      if (type === 'PACKAGES_SET') {
        this.item = cloneDeep(this.$store.getters.PACKAGES_ITEM(this.$route.params.consumer, this.$route.params.type, this.$route.params.id)) || {}
      }
    })
  },
  destroyed () { this.unsubscribe() },
  methods: {
    update (item) {
      Object.keys(item).forEach(key => {
        this.$set(this.item, key, item[key])
      })
      this.errors.name = typeof this.item.name === 'undefined' || this.item.name === null || this.item.name === ''
      this.errors.owner = typeof this.item.owner === 'undefined' || this.item.owner === null || this.item.owner === ''
    },
    save () {
      this.$store.dispatch('PACKAGES_UPDATE', {
        item: this.item,
        consumer: this.consumer,
        type: this.type,
        id: this.id
      })
        .then(() => {
          let message = 'fpStore.package.editor.update.success'
          if (this.isNew) {
            message = 'fpStore.package.editor.create.success'
          }
          this.$fpuiMessageBlock.success(this.$t(message))
          this.close()
        })
        .catch(err => this.$fpuiMessageBlock.error(err.message))
    },
    close () {
      this.$router.push(`/packages/${this.consumer}/${this.type}`)
    }
  }
}
</script>

<style lang='less'>
  @import "~@/shared/styles/_variables.less";

  .fpui-store-package-editor {
    .action-container {
      position: absolute;
      right: 10px;
      top: 20px;
      z-index: 10;
      font-size: 20px;
      color: @blue;
      i {
        display: inline-block;
        margin-left: 15px;
        cursor: pointer;
      }
    }
  }
</style>
